export const strings = {
    prefixAgo: null,
    prefixFromNow: null,
    suffixAgo: 'yn ôl',
    suffixFromNow: 'o hyn',
    seconds: 'llai na munud',
    minute: 'am funud',
    minutes: '%d munud',
    hour: 'tua awr',
    hours: 'am %d awr',
    day: 'y dydd',
    days: '%d diwrnod',
    month: 'tua mis',
    months: '%d mis',
    year: 'am y flwyddyn',
    years: '%d blynedd',
    wordSeparator: ' ',
};
